import React, { forwardRef, useCallback } from 'react';
import style from './ShippingSection.module.css';
import { useTranslation } from 'react-i18next';
import ShippingInfomationCN from './ShippingInformationCN';
import NewShippingInfomation from './NewShippingInfomation';

const ShippingSection = forwardRef(({
  languageCode,
  shippingCallback,
  shippingAddress,
  setAdd,
  selectAddressId,
  setSelectAddressId,
  setSelectAddress,
  // messageRef,
  message,
  fetchCustomer,
  onMessageChange
}, ref) => {
  const { t } = useTranslation();

  const handleMessageChange = useCallback((newMessage) => {
    if (onMessageChange) {
      onMessageChange(newMessage);
    }
  }, [onMessageChange]);
  
  return (
    <div className={style.container}>
      {languageCode === "CN" ? (
        <ShippingInfomationCN
          ref={ref}
          callback={shippingCallback}
          shippingAddress={shippingAddress}
          setAdd={setAdd}
          selectAddressId={selectAddressId}
          setSelectAddressId={setSelectAddressId}
          setSelectAddress={setSelectAddress}
          // messageRef={messageRef}
          message={message}
        />
      ) : (
        <NewShippingInfomation
          ref={ref}
          callback={shippingCallback}
          shippingAddress={shippingAddress}
          setAdd={setAdd}
          selectAddressId={selectAddressId}
          setSelectAddressId={setSelectAddressId}
          setSelectAddress={setSelectAddress}
          // messageRef={messageRef}
          message={message}
          fetchCustomer={fetchCustomer}
          onMessageChange={handleMessageChange}
        />
      )}
    </div>
  );
});

export default ShippingSection;